<p>add-lungs works!</p>
<div class="d-flex justify-content-between">
    <div>
        <h2 mat-dialog-title>Area Of Auscultation - Lungs </h2>
    </div>
    <div class="control-button">
        <button mat-button mat-dialog-close type="button" class="btn btn-sm  btn-outline-primary">
            <i class="ti ti-circle-x"></i>
        </button>
        <button type="button" class="btn btn-sm  btn-outline-primary">
            <i class="ti ti-device-floppy" (click)="save()"></i>
        </button>
    </div>
</div>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="lungs_form">
        <div class="row">
            <div class="col-md-4">
                <div class="form-group row mb-2">
                    <label>Name </label>
                    <div class="col-lg-12">
                        <input type="text" placeholder="Enter Name" formControlName="name" class="form-control">
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group row mb-2">
                    <label>Date </label>
                    <div class="col-lg-12">
                        <input type="date" placeholder="Enter Name" formControlName="date" class="form-control">
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group row mb-2">
                    <label>Selections</label>
                    <div class="col-md-12">
                        <select id="default" formControlName="selections" class="form-select">
                            <option>-</option>
                            <option>Normal</option>
                            <option>Rhonchi</option>
                            <option>B/L crepitation</option>
                            <option>Bronchial Breathing</option>
                            <option>Muffled Lung Sounds</option>
                            <option>Reduced air entry</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </form>
</mat-dialog-content>